<template>
  <div v-if="this.$route.query.type == 'edit'">
    <router-view />
  </div>
  <div v-else class="faq">
    <Modal v-model="modalUpdateTitle" title="名称及等级配置" :closable="false" :mask-closable="false"
      @on-ok="editTitleAndLevel">
      <div style="width: 100%; display: flex; align-items: center; justify-content: start;">
        <Poptip trigger="hover" :transfer="true" title="图片详情">
          <div class="info-pop" slot="content">
            <img :src="selectUrl">
          </div>
          <img :src="selectUrl" style="width: 120px;height: 120px;">
        </Poptip>
      </div>
      <p style="height: 30px; text-align: left;line-height: 30px;">商品名称：</p>
      <Input v-model="selectTitle" placeholder="请输入商品名称(限8个字)" clearable />
      <p style="height: 30px; text-align: left;line-height: 30px;">等级选择：</p>
      <RadioGroup v-model="selectLevel" type="button" button-style="solid">
        <Radio label="10"><span>SSS</span></Radio>
        <Radio label="9"><span>SS</span></Radio>
        <Radio label="8"><span>S</span></Radio>
        <Radio label="7"><span>A</span></Radio>
        <Radio label="6"><span>B</span></Radio>
        <Radio label="5"><span>C</span></Radio>
        <Radio label="4"><span>D</span></Radio>
        <Radio label="3"><span>E</span></Radio>
        <Radio label="2"><span>F</span></Radio>
        <Radio label="1"><span>G</span></Radio>
      </RadioGroup>
      <p style="height: 30px; text-align: left;line-height: 30px;">备注：商品名称限8个字，建议6字以下，适配客户端</p>
    </Modal>
    <Modal v-model="modalEditImage" title="替换图片" :closable="false" :mask-closable="false" @on-ok="editRecordImage">
      <p>图片：{{upload_image_name}}</p>
      <Upload action="" :before-upload="(file) =>  { return addImgRecord(file, 0)}" :multiple="true">
        <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
      <!-- <p>颜色：(可为空)</p>
	    <Input v-model="colorJson" placeholder="请输入颜色json" clearable /> -->
    </Modal>
    <Modal v-model="modalAdd" title="新增商品" :closable="false" :mask-closable="false" @on-ok="addRecord">
      <p>类型：</p>
      <Select v-model="addClassify" filterable>
        <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Input v-model="addQuestion" placeholder="问题" clearable /> -->
      <!-- <p>图片：</p>
      <Input type="textarea" :autosize="{minRows: 3}" v-model="addImages" placeholder="请输入图片名称，回车输入下一个" clearable/> -->
      <p>图片-商店-shop：{{shop_image_name}}</p>
      <Upload action="" :before-upload="addImageForShop" :multiple="true">
        <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
      <p>图片-站着-stand：{{stand_image_name}}</p>
      <Upload action="" :before-upload="addImageForStand" :multiple="true">
        <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
      <p>图片-坐着-sit：{{sit_image_name}}</p>
      <Upload action="" :before-upload="addImageForSit" :multiple="true">
        <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
      <p>图片-躺着-个人self：{{lie_self_image_name}}</p>
      <Upload action="" :before-upload="addImageForLieSelf" :multiple="true">
        <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
      <p>图片-躺着-俯视-front：{{lie_front_image_name}}</p>
      <Upload action="" :before-upload="addImageForLieFront" :multiple="true">
        <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
      <p>性别：</p>
      <Select v-model="addSex" filterable>
        <Option v-for="item in filterSex.slice(0,2)" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <p>用钻价格：</p>
      <Input v-model="addJewelPrice" placeholder="请输入用钻价格" clearable />
      <p>用币价格：</p>
      <Input v-model="addCoinPrice" placeholder="请输入用币价格" clearable />
      <p>折扣：</p>
      <Select v-model="addDiscount" filterable>
        <Option v-for="item in filterDiscount" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <p>状态：</p>
      <Select v-model="addStatus" filterable>
        <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Checkbox v-model="isUpdateTime">是否更新时间</Checkbox> -->
      <p>备注：用钻购买价格，-1为不可用钻购买；用币购买价格，-1为不可用币购买</p>
    </Modal>
    <Modal v-model="modalTagAdd" title="选择标签" :closable="false" :mask-closable="false" @on-ok="updateTags" @on-cancel="cancelTags">
      <p>款式标签：</p>
      <Select v-model="updateTagsType" filterable>
        <Option v-for="item in dataTypeTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
      </Select>
      <p>风格标签一：</p>
      <Select v-model="updateTagsStyleFirst" filterable>
        <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
      </Select>
      <Button type="primary" style="margin-top: 10px; margin-bottom: 10px;" @click="isShowTagTwo =!isShowTagTwo">风格标签二</Button>
      <p v-if="isShowTagTwo">风格标签二：</p>
      <Select v-if="isShowTagTwo" v-model="updateTagsStyleSeconds" filterable>
        <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
      </Select>
      <p>备注：款式标签必选一个,风格标签可选择0/1/2个</p>
    </Modal>
    <div class="headers">
      <span>分类：</span>
      <Select @on-change="changeSelect" v-model="classify" style="width: 80px">
        <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <span style="margin-left: 10px">性别：</span>
      <Select @on-change="changeSelect" v-model="sex" style="width: 80px">
        <Option v-for="item in filterSex" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <Button v-if="!isAllShop" @click="modalAdd = true">新增</Button>
      <Button v-if="!isAllShop" @click="sort_btn">{{sort_btn_msg}}</Button>
      <Button v-show="sortSaveBtn" @click="sort_save">保存</Button>
      <Button @click="getRecords">刷新</Button>
    </div>
    <Table :loading ='loading' stripe border highlight-row :columns="columns" :data="changeDataList" :height="tableHeight">
      <template slot-scope="{ row, index }" slot="id">
        <span>{{row.serial_number}}</span>
      </template>
      <template slot-scope="{ row, index }" slot="title">
        <span :style="">{{ row.title || '' }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="level">
        <!-- <span>{{ row.level | getLevel }}</span> -->
        <template>
          <Select v-model="row.level" filterable style="width: 75px;" @on-open-change="showLevelChangeList(row)" @on-change="handleChange(index, row)" placeholder='等级'>
            <Option v-for="item in filterLevel" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
      </template>
      <template slot-scope="{ row, index }" slot="coin_buy_count">
        <span>{{ row.coin_buy_count || 0 }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="jewel_buy_count">
        <span>{{ row.jewel_buy_count || 0 }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="url">
        <Poptip trigger="hover" :transfer="true" title="图片详情">
          <div class="info-pop" slot="content">
            <img :src="row.url">
          </div>
          <img :src="row.url" style="width: 86px;height: 86px;">
        </Poptip>
      </template>
      <template slot-scope="{ row, index }" slot="priority">
        <span>{{ row.priority }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="category_id">
        <template v-if="editIndex === index">
          <Select v-model="updateClassify" filterable style="width: 90px;">
            <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.category_id|getClassify }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="images">
        <template v-if="editIndex === index">
          <!--          <i-Input v-model="updateImages" />-->
          <Input type="textarea" :autosize="{minRows: 3}" v-model="updateImages" placeholder="请输入图片名称，回车输入下一个"
            clearable />
        </template>
        <span class="images-text" v-else>{{ row.images }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="sex">
        <template v-if="editIndex === index">
          <Select v-model="updateSex" filterable style="width: 60px;">
            <Option v-for="item in filterSex.slice(0,2)" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.sex|getSex }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="jewel_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateJewelPrice" />
        </template>
        <span v-else>{{ row.jewel_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="coin_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateCoinPrice" />
        </template>
        <span v-else>{{ row.coin_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="discount">
        <template v-if="editIndex === index">
          <Select v-model="updateDiscount" filterable style="width: 90px;">
            <Option v-for="item in filterDiscount" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.discount|getDiscount }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="status">
        <template v-if="editIndex === index">
          <Select v-model="updateStatus" filterable style="width: 70px;">
            <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.status|getStatus }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="tags">
        <template v-if="editIndex === index">
          <span class="images-text">{{ row.tags|getTagsEdit }}</span>
        </template>
        <span v-else class="images-text">{{ row.tags|getTags }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <div v-if="!sorting">
          <div v-if="editIndex === index" style="display: flex;">
            <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
            <Button style="margin-left: 10px" @click="editIndex = -1" :disabled="action_btn_disabled">取消</Button>
          </div>
          <div v-else>
            <Button  v-if="isAllShop" style="margin-top: 4px" @click="updateTitleAndLevel(row, index)">修改</Button>
            <Button v-if="!isAllShop" @click="handleEdit(row, index)">修改</Button>
            <Button v-if="!isAllShop" style="margin-left: 10px" @click="showSelectTags(row, index)">标签</Button>
            <!-- <div style="display:  none;">
				<Button style="margin-top: 10px" @click="handleEditPage(row, index)">编辑</Button>
			</div> -->
      
            <div style="display: flex;">
              <Button v-if="isAllShop" style="margin-top: 4px; margin-bottom: 4px;" @click="showSelectTags(row, index)">标签</Button>
              <Button v-if="!isAllShop" style="margin-top: 10px" @click="editImages(row, index)">替图</Button>
              <Button v-if="!isAllShop" style="margin-left: 10px; margin-top: 10px" @click="updateTitleAndLevel(row, index)">名称</Button>
            </div>
            <!-- <Button style="margin-left: 10px" @click="editImages(row, index)">替图</Button> -->
            <!-- <Button style="margin-left: 10px" @click="deleteRecord(row, index)">删除</Button> -->
          </div>
        </div>
        <div v-else>
          <Button :disabled="index === 0" style="border-radius: 50%" @click="handel_sort(row,index,'up')">上</Button>
          <Button :disabled="index === data.length -1" style="border-radius: 50%;margin-left: 5px"
            @click="handel_sort(row,index,'down')">下</Button>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
  import apis from "../../http/api";
  import OSS from 'ali-oss';

  export default {
    name: "faq",
    data() {
      return {
        isAllShop:false,
        tableHeight: 400,
        selectId: 0,
        selectIndex: -1,
        selectUrl: '',
        selectLevel: "0",
        selectBeforeLevel: "0",
        selectTitle: '',
        selectBeforeTitle: '',
        ossClient: null,
        shop_image_name: null,
        shop_image_data: null,
        stand_image_name: null,
        stand_image_data: null,
        sit_image_name: null,
        sit_image_data: null,
        lie_self_image_name: null,
        lie_self_image_data: null,
        lie_front_image_name: null,
        lie_front_image_data: null,

        filterDiscount: [{
          label: '可打折',
          value: 1
        }, {
          label: '不可打折',
          value: 0
        }],
        filterStatus: [{
          label: '正常',
          value: 0
        }, {
          label: '下架',
          value: -1
        }, {
          label: '赠品',
          value: -2
        }],
        filterClassify: [{
            label: '表情',
            value: 1
          }, {
            label: '刘海',
            value: 2
          }, {
            label: '发型',
            value: 3
          },
          {
            label: '上装',
            value: 4
          }, {
            label: '下装',
            value: 5
          }, {
            label: '袜子',
            value: 6
          },
          {
            label: '鞋子',
            value: 7
          }, {
            label: '头饰',
            value: 8
          }, {
            label: '耳环',
            value: 9
          },
          {
            label: '脸部饰品',
            value: 10
          }, {
            label: '项链',
            value: 11
          }
        ],
        filterLevel: [{
            label: 'SSS',
            value: 10
          },
          {
            label: 'SS',
            value: 9
          },
          {
            label: 'S',
            value: 8
          },
          {
            label: 'A',
            value: 7
          },
          {
            label: 'B',
            value: 6
          },
          {
            label: 'C',
            value: 5
          },
          {
            label: 'D',
            value: 4
          },
          {
            label: 'E',
            value: 3
          },
          {
            label: 'F',
            value: 2
          },
          {
            label: 'G',
            value: 1
          }
        ],
        classify: 1,
        filterSex: [{
          label: '女',
          value: 0
        }, {
          label: '男',
          value: 1
        }, {
          label: '全部',
          value: -1
        }],
        sex: 0, // 0女，1男，-1全部
        data: [],
        tmpData: [],
        modalUpdateTitle: false,
        modalAdd: false,
        modalEditImage: false,
        action_btn_disabled: false,
        sortSaveBtn: false,
        update_question: "",
        update_answer: "",
        update_faq_id: null,
        editIndex: -1,
        sorting: false,
        sortBtnDesc: "排序",
        addClassify: 1,
        addImages: "",
        addSex: 0,
        addDiscount: 0,
        addJewelPrice: null,
        addCoinPrice: null,
        addStatus: 0,
        updateClassify: '',
        updateImages: "",
        updateSex: 0,
        updateDiscount: 0,
        updateJewelPrice: null,
        updateCoinPrice: null,
        updateStatus: 0,
        modalTagAdd: false,
        updateTagsIndex: -1,
        dataTypeTags: [],
        dataStyleTags: [],
        updateTagsPropId: -1,
        updateTagsType: 0,
        updateTagsStyleFirst: 0,
        updateTagsStyleSeconds: 0,
        isShowTagTwo: false,
        updateTagsArray: [],
        updateLevelItem: null,
        loading:false,
        columns: [{
            title: '缩略图',
            slot: 'url',
            width: 120,
            fixed: 'left',
          },
          {
            title: '编号',
            slot: 'id',
            width: 80
          },
          {
            title: '商品名称',
            slot: 'title',
            width: 150,
            filters: [
              {
                label: '名称为空',
                value: 1
              },
              {
                label: '名称非空',
                value: 2
              }
            ],
            filterMultiple: false,
            filterMethod (value, row) {
              if (value === 2) {
                return row.title && row.title.length > 0 && !row.title.includes('测试') ;
              } else if (value === 1) {
                return row.title == undefined || row.title.length == 0 || row.title.includes('测试');
              }
            }
          },
          {
            title: '等级',
            slot: 'level',
            key:'level',
            width: 95,
            filters: [
              {
                label: 'SSS',
                value: 10
              },
              {
                label: 'SS',
                value: 9
              },
              {
                label: 'S',
                value: 8
              },
              {
                label: 'A',
                value: 7
              },
              {
                label: 'B',
                value: 6
              },
              {
                label: 'C',
                value: 5
              },
              {
                label: 'D',
                value: 4
              },
              {
                label: 'E',
                value: 3
              },
              {
                label: 'F',
                value: 2
              },
              {
                label: 'G',
                value: 1
              },
              {
                label: '无',
                value: 0
              }
            ],
            filterMultiple: true,
            filterMethod (value, row) {
              return row.level == value
            },
            sortable: true,
          },
          {
            title: '类型',
            slot: 'category_id',
            width: 100
          },
          {
            title: '性别',
            slot: 'sex',
            width: 70
          },
          {
            title: '用钻价格',
            slot: 'jewel_price',
            key:'jewel_price',
            width: 125,
            filters: [
              {
                label: '0-50',
                value: 1
              },
              {
                label: '51-100',
                value: 2
              },
              {
                label: '101-150',
                value: 3
              },
              {
                label: '151-200',
                value: 4
              },
              {
                label: '201-250',
                value: 5
              },
              {
                label: '251-300',
                value: 6
              },
              {
                label: '301-350',
                value: 7
              },
              {
                label: '351-400',
                value: 8
              },
              {
                label: '400以上',
                value: 9
              }
            ],
            filterMultiple: false,
            filterMethod (value, row) {
              if (value === 1) {
                return row.jewel_price >= 0 && row.jewel_price <= 50;
              } else if (value === 2) {
                return row.jewel_price >= 51 && row.jewel_price <= 100;
              } else if (value === 3) {
                return row.jewel_price >= 101 && row.jewel_price <= 150;
              } else if (value === 4) {
                return row.jewel_price >= 151 && row.jewel_price <= 200;
              } else if (value === 5) {
                return row.jewel_price >= 201 && row.jewel_price <= 250;
              } else if (value === 6) {
                return row.jewel_price >= 251 && row.jewel_price <= 300;
              } else if (value === 7) {
                return row.jewel_price >= 301 && row.jewel_price <= 350;
              } else if (value === 8) {
                return row.jewel_price >= 351 && row.jewel_price <= 400;
              } else if (value === 9) {
                return row.jewel_price >= 401;
              }
            },
            sortable: true,
          },
          {
            title: '用钻销量',
            slot: 'jewel_buy_count',
            key:'jewel_buy_count',
            width: 110,
            sortable: true,
          },
          {
            title: '用币价格',
            slot: 'coin_price',
            width: 110,
            filters: [
              {
                label: 'Co币>=0',
                value: 1
              },
              {
                label: 'Co币<0',
                value: 2
              }
            ],
            filterMultiple: false,
            filterMethod (value, row) {
              if (value === 1) {
                return row.coin_price >= 0;
              } else if (value === 2) {
                return row.coin_price < 0;
              }
            }
          },
          {
            title: '用币销量',
            slot: 'coin_buy_count',
            key:'coin_buy_count',
            width: 110,
            sortable: true,
          },
          {
            title: '折扣',
            slot: 'discount',
            width: 100
          },
          {
            title: '状态',
            slot: 'status',
            width: 80
          },
          {
            title: '标签',
            slot: 'tags',
            key:'tags',
            width: 100,
            filters: [],
            filterMultiple: true,
            filterMethod(value, row) {
              return row.tags.includes(value);
            }
          },
          {
            title: '图片',
            slot: 'images',
            width: 220
          },
          {
            title: '优先级',
            slot: 'priority',
            width: 80
          },
          {
            title: '操作',
            slot: 'action',
            width: 160,
            fixed: 'right',
          }
        ]
      }
    },
    async created() {
      this.isAllShop = this.$route.query.shop_id == 999
      this.tableHeight = window.innerHeight - 150
      window.addEventListener('resize', this.handleResize);
      this.getOss();
      this.initCurrentColumns()
      await this.getRecords()
    },
    watch: {
      // 如果退出编辑将多选框置为false
      editIndex: function(newVal, oldVal) {
        if (newVal === -1) {
          this.isUpdateTime = false
        }
      },
      modalAdd: function(newVal, oldVal) {
        if (newVal) {
          this.addClassify = this.classify;
          this.addSex = this.sex !== -1 ? this.sex : 1
        }
      },
      modalTagAdd: function(newVal, oldVal) {
        if (newVal) {}
      }
    },
    methods: {
      showLevelChangeList(val){
        this.updateLevelItem = val.level
      },
      handleChange(index, row){
        if(row.level != this.updateLevelItem){
          this.editLevel(index, row , this.updateLevelItem)
        }
      },
      initCurrentColumns(){
        if(this.isAllShop){
          this.columns = [
            {
                title: '缩略图',
                slot: 'url',
                width: 100
              },
              {
                title: '编号',
                slot: 'id',
                width: 80
              },
              {
                title: '商品名称',
                slot: 'title',
                width: 0,
                filters: [
                  {
                    label: '名称为空',
                    value: 1
                  },
                  {
                    label: '名称非空',
                    value: 2
                  }
                ],
                filterMultiple: false,
                filterMethod (value, row) {
                  if (value === 2) {
                    return row.title && row.title.length > 0 && !row.title.includes('测试') ;
                  } else if (value === 1) {
                    return row.title == undefined || row.title.length == 0 || row.title.includes('测试');
                  }
                }
              },
              {
                title: '等级',
                slot: 'level',
                key:'level',
                width: 95,
                filters: [
                  {
                    label: 'SSS',
                    value: 10
                  },
                  {
                    label: 'SS',
                    value: 9
                  },
                  {
                    label: 'S',
                    value: 8
                  },
                  {
                    label: 'A',
                    value: 7
                  },
                  {
                    label: 'B',
                    value: 6
                  },
                  {
                    label: 'C',
                    value: 5
                  },
                  {
                    label: 'D',
                    value: 4
                  },
                  {
                    label: 'E',
                    value: 3
                  },
                  {
                    label: 'F',
                    value: 2
                  },
                  {
                    label: 'G',
                    value: 1
                  },
                  {
                    label: '无',
                    value: 0
                  }
                ],
                filterMultiple: true,
                filterMethod (value, row) {
                  return row.level == value
                },
                sortable: true,
              },
              {
                title: '用钻价格',
                slot: 'jewel_price',
                key:'jewel_price',
                width: 125,
                filters: [
                  {
                    label: '0-50',
                    value: 1
                  },
                  {
                    label: '51-100',
                    value: 2
                  },
                  {
                    label: '101-150',
                    value: 3
                  },
                  {
                    label: '151-200',
                    value: 4
                  },
                  {
                    label: '201-250',
                    value: 5
                  },
                  {
                    label: '251-300',
                    value: 6
                  },
                  {
                    label: '301-350',
                    value: 7
                  },
                  {
                    label: '351-400',
                    value: 8
                  },
                  {
                    label: '400以上',
                    value: 9
                  }
                ],
                filterMultiple: false,
                filterMethod (value, row) {
                  if (value === 1) {
                    return row.jewel_price >= 0 && row.jewel_price <= 50;
                  } else if (value === 2) {
                    return row.jewel_price >= 51 && row.jewel_price <= 100;
                  } else if (value === 3) {
                    return row.jewel_price >= 101 && row.jewel_price <= 150;
                  } else if (value === 4) {
                    return row.jewel_price >= 151 && row.jewel_price <= 200;
                  } else if (value === 5) {
                    return row.jewel_price >= 201 && row.jewel_price <= 250;
                  } else if (value === 6) {
                    return row.jewel_price >= 251 && row.jewel_price <= 300;
                  } else if (value === 7) {
                    return row.jewel_price >= 301 && row.jewel_price <= 350;
                  } else if (value === 8) {
                    return row.jewel_price >= 351 && row.jewel_price <= 400;
                  } else if (value === 9) {
                    return row.jewel_price >= 401;
                  }
                },
                sortable: true,
              },
              {
                title: '用钻销量',
                slot: 'jewel_buy_count',
                key:'jewel_buy_count',
                width: 110,
                sortable: true,
              },
              {
                title: '用币价格',
                slot: 'coin_price',
                width: 110,
                filters: [
                  {
                    label: 'Co币>=0',
                    value: 1
                  },
                  {
                    label: 'Co币<0',
                    value: 2
                  }
                ],
                filterMultiple: false,
                filterMethod (value, row) {
                  if (value === 1) {
                    return row.coin_price >= 0;
                  } else if (value === 2) {
                    return row.coin_price < 0;
                  }
                }
              },
              {
                title: '用币销量',
                slot: 'coin_buy_count',
                key:'coin_buy_count',
                width: 110,
                sortable: true,
              },
              {
                title: '状态',
                slot: 'status',
                width: 70
              },
              {
                title: '标签',
                slot: 'tags',
                key:'tags',
                width: 100,
                filters: [],
                filterMultiple: true,
                filterMethod(value, row) {
                return row.tags.includes(value);
                }
              },
              {
                title: '操作',
                slot: 'action',
                width: 100,
              }
          ]
        }
        return this.columns
      },
      handleResize() {
        this.tableHeight = window.innerHeight - 150
      },
      async getOss() {
        apis.get_oss().then(res => {
          this.ossClient = new OSS({
            region: 'oss-cn-shanghai',
            accessKeyId: res.AccessKeyId,
            accessKeySecret: res.AccessKeySecret,
            stsToken: res.SecurityToken,
            bucket: 'co-study',
          })
        }).catch(err => {
          console.log(err)
        })
      },
      addImageForShop(event) {
        return this.addImgRecord(event, 1)
      },
      addImageForStand(event) {
        return this.addImgRecord(event, 2)
      },
      addImageForSit(event) {
        return this.addImgRecord(event, 3)
      },
      addImageForLieSelf(event) {
        return this.addImgRecord(event, 4)
      },
      addImageForLieFront(event) {
        return this.addImgRecord(event, 5)
      },
      addImgRecord(event, type) {
        try {
          let ts = (new Date()).valueOf();
          let filename = '.' + event.name.split('.').pop();
          if (filename !== '.png') {
            this.$Message.error('仅支持上传png格式的图片');
            return Promise.reject()
          }
          let timestamp = Date.now()
          timestamp = parseInt(timestamp / 1000)

          let min = 1000
          let max = 9999
          parseInt(Math.random() * (max - min + 1) + min, 10);
          let random = Math.floor(Math.random() * (max - min + 1) + min);

          filename = this.$route.query.shop_id + '_' + timestamp + '_' + random + '.png'
          console.log(filename)
          if (this.classify === null) {
            this.$Message.error('请先选择类型');
            return Promise.reject()
          }
          if (type === 1) {
            this.shop_image_name = filename
            this.shop_image_data = event
          } else if (type === 2) {
            this.stand_image_name = filename
            this.stand_image_data = event
          } else if (type === 3) {
            this.sit_image_name = filename
            this.sit_image_data = event
          } else if (type === 4) {
            this.lie_self_image_name = filename
            this.lie_self_image_data = event
          } else if (type === 5) {
            this.lie_front_image_name = filename
            this.lie_front_image_data = event
          }
          //      let result = await this.ossClient.put(this.shop_image_name, this.shop_image_data);
          //      if (result.res.status === 200) {
          // this.$Message.success('上传成功');
          //      } else {
          //          console.log(result)
          //          this.$Message.error('上传至oss失败');
          //      }
        } catch (e) {
          console.log(e);
          this.$Message.error('上传至oss失败');
        }
        return Promise.reject()
      },

      async upload_image_to_oss() {
        let oss_url = 'app/image/figure/new_part/'
        if (this.sex === 1) {
          oss_url = oss_url + 'boy/'
        } else {
          oss_url = oss_url + 'girl/'
        }
        let result = null
        if (this.shop_image_data) {
          result = await this.ossClient.put(oss_url + this.shop_image_name, this.shop_image_data);
          if (result.res.status === 200) {
            // this.$Message.success('上传成功');
          } else {
            return false
          }
        }

        if (this.stand_image_data) {
          result = await this.ossClient.put(oss_url + this.stand_image_name, this.stand_image_data);
          if (result.res.status === 200) {
            // this.$Message.success('上传成功');
          } else {
            return false
          }
        }

        if (this.sit_image_data) {
          result = await this.ossClient.put(oss_url + this.sit_image_name, this.sit_image_data);
          if (result.res.status === 200) {
            // this.$Message.success('上传成功');
          } else {
            return false
          }
        }

        if (this.lie_self_image_data) {
          result = await this.ossClient.put(oss_url + this.lie_self_image_name, this.lie_self_image_data);
          if (result.res.status === 200) {
            // this.$Message.success('上传成功');
          } else {
            return false
          }
        }

        if (this.lie_front_image_data) {
          result = await this.ossClient.put(oss_url + this.lie_front_image_name, this.lie_front_image_data);
          if (result.res.status === 200) {
            // this.$Message.success('上传成功');
          } else {
            return false
          }
        }

        return true
      },
      async getRecords() {
        if(this.isAllShop){
           this.loading = true
        }
        let params = {
          'category_id': this.classify,
          'sex': this.sex,
          'shop_id': this.$route.query.shop_id
        }
        apis.image_shop_by_category(params).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode === 0) {
            this.data = data.records
            for (var i = 0; i < this.columns.length; i++) {
              if(this.columns[i].key == 'tags'){
                this.columns[i].filters = []
                const keys = []
                for (var j = 0; j < this.data.length; j++) {
                  if(this.data[j].tags.length == 0){
                    continue;
                  }
                  const tags = this.data[j].tags.split('\n')
                  for (var k = 0; k < tags.length; k++) {
                    if(keys.includes(tags[k])){
                      continue
                    }
                    keys.push(tags[k])
                  }
                }
                for (var k = 0; k < keys.length; k++) {
                  const item ={
                    label: keys[k],
                    value: keys[k]
                  }
                  this.columns[i].filters.push(item)
                }
              }
            }
            if(this.isAllShop){
              this.loading = false
            }
          }
        }).catch(err => {
            if(this.isAllShop){
              this.loading = false
            }
        })
      },
      showSelectTags(row, index) {
        this.updateTagsPropId = row.id
        this.updateTagsType = 0
        this.updateTagsStyleFirst = 0
        this.updateTagsStyleSeconds = 0
        this.isShowTagTwo = false
        this.modalTagAdd = false
        this.dataStyleTags = []
        this.dataTypeTags = []
        this.updateTagsArray = row.tags.split(/[\s\n]/)
        this.updateTagsIndex = index
        this.getClothesTags(row.sex)
      },
      getClothesTags(prop_sex) {
        let params = {
          'category_ids': this.classify,
          'sex': prop_sex,
        }
        apis.figure_shop_get_clothes_tags(params).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode === 0) {
            data.style_tags.unshift({
              'id': 0,
              'title': '空'
            })
            this.dataTypeTags = data.type_tags
            this.dataStyleTags = data.style_tags
            let hasType = false
            this.updateTagsArray.forEach(record => {
              if (typeof(record) === 'string' && record.length > 0) {
                this.dataTypeTags.forEach(item => {
                  if (typeof(item.title) === 'string' && item.title.length > 0 && record === item.title) {
                    if (this.updateTagsType === 0) {
                      this.updateTagsType = item.id
                      hasType = true
                      return false
                    }
                  }
                });
                if (hasType === true) {
                  this.dataStyleTags.forEach(item => {
                    if (typeof(item.title) === 'string' && item.title.length > 0 && record === item.title) {
                      if (this.updateTagsStyleFirst === 0) {
                        this.updateTagsStyleFirst = item.id
                      } else if (this.updateTagsStyleSeconds === 0) {
                        this.updateTagsStyleSeconds = item.id
                      }
                    }
                  });
                }
              }
            });
            this.modalTagAdd = true
          } else {
            this.$Message.error('获取标签列表失败');
          }
        }).catch(err => {
          this.$Message.error('获取标签列表失败');
        })
      },
      cancelTags(){
        this.updateTagsPropId = 0
        this.updateTagsType = 0
        this.updateTagsStyleFirst = 0
        this.updateTagsStyleSeconds = 0
        this.isShowTagTwo = false
        this.modalTagAdd = false
        this.dataStyleTags = []
        this.dataTypeTags = []
        this.updateTagsArray = []
        this.updateTagsIndex = -1
      },
      updateTags() {
        console.log("test info updateTagsPropId :  " + this.updateTagsPropId)
        console.log("test info updateTagsIndex :  " + this.updateTagsIndex)
        if (!this.updateTagsPropId > 0) {
          this.$Message.error('请选择商品!');
          this.cancelTags()
          return
        }
        if (this.updateTagsIndex < 0) {
          this.$Message.error('请选择商品');
          this.cancelTags()
          return
        }
        if (!this.updateTagsType > 0) {
          this.$Message.error('款式标签不能为空');
          this.cancelTags()
          return
        }
        // 当弹窗不展示风格标签二时，强制清除标签二的内容
        if(!this.isShowTagTwo){
          this.updateTagsStyleSeconds = 0
        }
        if (this.updateTagsStyleFirst != 0 && this.updateTagsStyleSeconds != 0 && this.updateTagsStyleFirst === this
          .updateTagsStyleSeconds) {
          this.$Message.error('风格标签一和风格标签二不能一样！');
          this.cancelTags()
          return
        }
        let styleTagIds = ""
        if (this.updateTagsStyleFirst === 0 && this.updateTagsStyleSeconds === 0) {

        } else if (this.updateTagsStyleFirst === 0 || this.updateTagsStyleSeconds === 0) {
          styleTagIds = this.updateTagsStyleFirst == 0 ? "" + this.updateTagsStyleSeconds : "" + this
            .updateTagsStyleFirst
        } else {
          styleTagIds = this.updateTagsStyleFirst + "," + this.updateTagsStyleSeconds
        }
        console.log("test info styleIds :  " + styleTagIds)
        let post_data = {
          figure_image_id: this.updateTagsPropId,
          type_tag_id: this.updateTagsType,
          style_tag_ids: styleTagIds,
        }
        apis.figure_shop_post_clothes_bind_tag(post_data).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode !== 0) {
            console.log("test info error :  " + msg)
            this.$Message.error(msg);
            this.cancelTags()
            return
          }
          let newTags = ''
          this.dataTypeTags.forEach(item => {
            if (typeof(item.title) === 'string' && item.title.length > 0 && item.id === this.updateTagsType) {
              newTags = item.title
            }
          });
          let firstTag =''
          let secondTag = ''
          this.dataStyleTags.forEach(item => {
            if (typeof(item.title) === 'string' && item.title.length > 0 ) {
              if(item.id !=0 && item.id === this.updateTagsStyleFirst){
                firstTag = item.title
              }
              if(item.id !=0 && item.id === this.updateTagsStyleSeconds){
                secondTag = item.title
              }
            }
          });
          if(newTags.length>0){
            if(firstTag.length>0){
              newTags = newTags + '\n'+ firstTag
            }
            if(secondTag.length>0){
              newTags = newTags + '\n'+ secondTag
            }
          }
          this.data[this.updateTagsIndex].tags = newTags
          this.$Message.success('标签设置成功！'); 
          this.cancelTags()
          // 远程更新
          // this.getRecords()
        })
      },
      async editRecordImage() {
        console.log('xxxxx')
        let upload_result = await this.upload_image_to_oss()
        if (!upload_result) {
          this.$Message.error('图片上传失败');
          return
        }
        var images_dict = {}
        if (this.colorJson) {
          var color_dict = JSON.parse(this.colorJson)
          if (typeof color_dict != 'object') {
            this.$Message.error('格式错误!');
            return
          }
          console.log(color_dict)
          let keys = ['bed_boy_word_color', 'bed_girl_word_color', 'bed_word', 'bed_clock_color',
            'bed_word_border_color', 'theme_key', 'shop'
          ]
          for (var key in color_dict) {
            if (!keys.find(item => item === key)) {
              this.$Message.error('名称错误' + key);
              return
            } else {
              images_dict[key] = color_dict[key]
            }
          }
        }
        if (this.upload_image_data) {
          for (let i = 0; i < this.upload_image_data.length; i++) {
            let tmp_dict = this.upload_image_data[i]
            images_dict[tmp_dict['key']] = tmp_dict['filename']
          }
        }
        this.upload_image_data = null
        this.upload_image_name = null
        let post_data = {
          images: JSON.stringify(images_dict),
          furniture_id: this.updateTagsPropId
        }
        console.log(post_data)
        apis.figure_shop_update_record_json(post_data).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode !== 0) {
            this.$Message.error(msg);
          }
          this.getRecords()
        })
      },
      async addRecord() {
        if (this.addClassify === 7 || this.addClassify === 6 || this.addClassify === 5) {
          if (!this.shop_image_name || !this.stand_image_name) {
            this.$Message.error('图片不能为空');
            return
          }
        } else {
          if (!this.shop_image_name || !this.stand_image_name || !this.sit_image_name || !this.lie_front_image_name ||
            !this.lie_self_image_name) {
            this.$Message.error('图片不能为空');
            return
          }
        }
        if (!this.addJewelPrice) {
          this.$Message.error('钻价格不能为空');
          return
        }
        if (!this.addCoinPrice) {
          this.$Message.error('币价格不能为空');
          return
        }
        let upload_result = await this.upload_image_to_oss()
        if (!upload_result) {
          this.$Message.error('图片上传失败');
          return
        } else {
          this.$Message.error('图片上传成功');
        }
        let prefix_url = ''
        if (this.sex === 1) {
          prefix_url = 'boy/'
        } else {
          prefix_url = 'girl/'
        }
        var images_dict = {}
        if (this.shop_image_name) {
          images_dict['shop'] = prefix_url + this.shop_image_name
        }
        if (this.stand_image_name) {
          images_dict['stand'] = prefix_url + this.stand_image_name
        }
        if (this.sit_image_name) {
          images_dict['sit'] = prefix_url + this.sit_image_name
        }
        if (this.lie_self_image_name) {
          images_dict['lie_self'] = prefix_url + this.lie_self_image_name
        }
        if (this.lie_front_image_name) {
          images_dict['lie_front'] = prefix_url + this.lie_front_image_name
        }

        console.log(images_dict)
        this.addImages = JSON.stringify(images_dict)
        let post_data = {
          category_id: this.addClassify,
          sex: this.addSex,
          images: this.addImages,
          jewel_price: this.addJewelPrice,
          coin_price: this.addCoinPrice,
          discount: this.addDiscount,
          status: this.addStatus,
          shop_id: this.$route.query.shop_id,
        }
        console.log(post_data)
        await apis.image_shop_upload(post_data).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode === 0) {
            this.addImages = ""
            this.addJewelPrice = null
            this.addCoinPrice = null
            this.shop_image_name = null
            this.shop_image_data = null
            this.stand_image_name = null
            this.stand_image_data = null
            this.sit_image_name = null
            this.sit_image_data = null
            this.lie_self_image_name = null
            this.lie_self_image_data = null
            this.lie_front_image_name = null
            this.lie_front_image_data = null
          } else {
            this.$Message.error(msg);
          }
        }).catch(res => {
          this.$Message.error(res.toString());
        })

        await this.getRecords()
      },
      updateRecord(index) {
        if (!this.updateImages) {
          this.$Message.error('图片不能为空');
          return
        }
        if (!this.updateJewelPrice) {
          this.$Message.error('钻价格不能为空');
          return
        }
        if (!this.updateCoinPrice) {
          this.$Message.error('币价格不能为空');
          return
        }
        let post_data = {
          id: this.data[index].id,
          category_id: this.updateClassify,
          sex: this.updateSex,
          images: this.updateImages,
          jewel_price: this.updateJewelPrice,
          coin_price: this.updateCoinPrice,
          discount: this.updateDiscount,
          status: this.updateStatus,
        }
        apis.image_shop_update_record(post_data).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode !== 0) {
            this.$Message.error(msg);
          }
          this.getRecords()
        })
      },
      // deleteRecord(row, index) {
      //   this.data.splice(index, 1)
      //   let post_data = {
      //     id: row.id,
      //     classify: this.classify,
      //     records: this.data
      //   }
      //   apis.faq_delete_record(post_data).then(res => {
      //     const { data, errCode, msg } = res;
      //     if (errCode === 0) {
      //       this.refreshRecords()
      //     }
      //   }).catch()
      // },
      editImages(row, index) {
        console.log(row, index)
        this.updateTagsPropId = row.id
        this.modalEditImage = true
      },
      handleEdit(row, index) {
        this.action_btn_disabled = false;
        this.updateClassify = row.category_id;
        console.log(row.classify);
        this.updateImages = row.images;
        this.updateSex = row.sex;
        console.log(row.sex)
        this.updateDiscount = row.discount;
        this.updateJewelPrice = row.jewel_price;
        this.updateCoinPrice = row.coin_price;
        this.updateStatus = row.status;
        console.log(row.status)
        this.editIndex = index;
      },
      handleSave(index) {
        this.action_btn_disabled = true;
        this.updateRecord(index);
        this.editIndex = -1;
      },
      handleEditPage(row, index) {
        this.$router.push({
          path: '/shop/shop/manager/edit',
          query: {
            shop_id: this.$route.query.shop_id,
            type: 'edit'
          }
        })
      },
      updateTitleAndLevel(row, index) {
        this.selectId = row.id || 0
        this.selectUrl= row.url || ''
        this.selectIndex = index
        this.selectTitle = row.title || ''
        this.selectBeforeTitle = row.title || ''
        this.selectLevel = row.level.toString() || '0'
        this.selectBeforeLevel = row.level.toString() || '0'
        this.modalUpdateTitle = true
      },
      editTitleAndLevel() {
        const title = this.selectTitle || ''
        let post_data = {
          id: this.selectId,
        }
        if(title.trim() != this.selectBeforeTitle.trim()){
          post_data['title'] = title
        }
        if(this.selectLevel != this.selectBeforeLevel){
           post_data['level'] = this.selectLevel
        }
        
        if(post_data['title'] == undefined && post_data['level'] == undefined){
          // 无修改
          // this.$Message.error('无修改');
          return 
          // if (title.trim().length <=0) {
          //   this.$Message.error('商品名称不能为空！');
          //   return
          // }
          // if (this.selectLevel === "0" ) {
          //   this.$Message.error('请选择等级！');
          //   return
          // }
        }
        apis.image_shop_update_title(post_data).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode !== 0) {
            this.$Message.error(msg);
            return
          }
          this.data[this.selectIndex].title = title
          this.data[this.selectIndex].level = parseInt(this.selectLevel, 10)
          this.$Message.success('修改成功！'); 
          // this.getRecords()
        })
      },
      editLevel(index, row , beforeLevel) {
        console.log('test info = ',index, row, beforeLevel)
        if(row.id == undefined ||  row.id <= 0){
          this.$Message.error('修改失败，id为空');
          return 
        }
        let post_data = {
          id: row.id,
          level: row.level
        }
        if(post_data['level'] == undefined){
          return 
        }
        apis.image_shop_update_title(post_data).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode !== 0) {
            this.$Message.error(msg);
            this.data[index].level = beforeLevel
            return
          }
          this.$Message.success('等级修改成功！'); 
          this.data[index].level = row.level
        })
      },
      sort_btn() {
        if (this.sex === -1) {
          this.$Message.warning('全部性别下不可排序');
          return
        }
        this.sorting = !this.sorting
        this.sortSaveBtn = !this.sortSaveBtn
        if (!this.sorting) {
          // 深拷贝
          let tmp = JSON.stringify(this.tmpData)
          this.data = JSON.parse(tmp)
        } else {
          // 深拷贝
          let tmp = JSON.stringify(this.data)
          this.tmpData = JSON.parse(tmp)
        }
      },
      handel_sort(row, index, action) {
        let index2 = action === "up" ? index - 1 : index + 1;
        let index1 = index;
        // 将当前位置的值取出来替换为另一个值并将当前取出来的值赋给另一个值
        this.data[index1] = this.data.splice(index2, 1, this.data[index1])[0]
      },
      sort_save() {
        this.sorting = !this.sorting
        this.sortSaveBtn = !this.sortSaveBtn
        let post_data = {
          records: this.data,
          classify: this.classify,
          sex: this.sex
        }
        apis.image_shop_sort_records(post_data).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode === 0) {
            this.getRecords()
          }
        })
      },
      async changeSelect() {
        await this.getRecords()
      }
    },
    computed: {
      sort_btn_msg() {
        return this.sorting ? "取消" : "排序"
      },
      changeDataList() {
        return this.data.map(item => {
          item['jewel_buy_count'] =  item['jewel_buy_count'] || 0;
          item['coin_buy_count'] =  item['coin_buy_count'] || 0;
          return item
        })
      }
    },
    filters: {
      getClassify(val) {
        let categoryClassifyMap = {
          1: '表情',
          2: '刘海',
          3: '发型',
          4: '上装',
          5: '下装',
          6: '袜子',
          7: '鞋子',
          8: '头饰',
          9: '耳环',
          10: '脸部饰品',
          11: '项链'
        }
        return categoryClassifyMap[val]
      },
      getLevel(val) {
        let levelMap = {
          0: '',
          1: 'G',
          2: 'F',
          3: 'E',
          4: 'D',
          5: 'C',
          6: 'B',
          7: 'A',
          8: 'S',
          9: 'SS',
          10: 'SSS'
        }
        return levelMap[val]
      },
      getSex(val) {
        if (val === 0) {
          return '女'
        } else {
          return '男'
        }
      },
      getDiscount(val) {
        if (val > 0) {
          return '可打折'
        } else {
          return '不可打折'
        }
      },
      getStatus(val) {
        if (val === 0) {
          return '正常'
        } else if (val === -1) {
          return '下架'
        } else if (val === -2) {
          return '赠品'
        } else {
          return '异常'
        }
      },
      getTags(val) {
        if (val === "") {
          return '暂无'
        } else {
          return val
        }
      },
      getTagsEdit(val) {
        if (val === "") {
          return '暂无'
        } else {
          return "\n\n\n\n\n\n" + val + "\n\n\n\n\n\n"
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .faq /deep/ .ivu-table-cell {
    min-height: 33px;
    display: flex;
    justify-content center;
    align-items: center;
  }

  .faq {
    margin: 10px;
  }

  .headers {
    text-align: center;
    margin-bottom: 10px;
  }

  .headers button {
    margin-left: 10px;
  }

  .images-text {
    white-space: pre-wrap;
  }
</style>